var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMytemplate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.1334 2H3.46672C3.09853 2 2.80005 2.29848 2.80005 2.66667V6C2.80005 6.36819 3.09853 6.66667 3.46672 6.66667H14.1334C14.5016 6.66667 14.8 6.36819 14.8 6V2.66667C14.8 2.29848 14.5016 2 14.1334 2Z",
    fill: "white",
    stroke: "#172B4D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.80005 9.33301H3.46672C3.09853 9.33301 2.80005 9.63148 2.80005 9.99967V13.333C2.80005 13.7012 3.09853 13.9997 3.46672 13.9997H6.80005C7.16824 13.9997 7.46672 13.7012 7.46672 13.333V9.99967C7.46672 9.63148 7.16824 9.33301 6.80005 9.33301Z",
    fill: "white",
    stroke: "#172B4D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1334 9.33301H10.8C10.4318 9.33301 10.1334 9.63148 10.1334 9.99967V13.333C10.1334 13.7012 10.4318 13.9997 10.8 13.9997H14.1334C14.5016 13.9997 14.8 13.7012 14.8 13.333V9.99967C14.8 9.63148 14.5016 9.33301 14.1334 9.33301Z",
    fill: "white",
    stroke: "#172B4D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMytemplate);
export default __webpack_public_path__ + "static/media/mytemplate.bc7d0629fedecec7978451e02e829b33.svg";
export { ForwardRef as ReactComponent };